import ArtMetal from '../../assets/img/OurReferences/Construction/ArtMetal.webp'
import Atmacan from '../../assets/img/OurReferences/Construction/Atmacan.webp'
import Aydogdu from '../../assets/img/OurReferences/Construction/AYDOGDU.webp'
import EzeInsaat from '../../assets/img/OurReferences/Construction/EzeInsaat.webp'
import Fernas from '../../assets/img/OurReferences/Construction/Fernas.webp'
import goldIskele from '../../assets/img/OurReferences/Construction/goldIskele.webp'
import KozaIskele from '../../assets/img/OurReferences/Construction/KozaIskele.webp'
import MetGun from '../../assets/img/OurReferences/Construction/Met-Gun.webp'
import MdInsaat from '../../assets/img/OurReferences/Construction/MdInsaat.webp'
import Kirik from '../../assets/img/OurReferences/Construction/Kirik.webp'
import Teksanlar from '../../assets/img/OurReferences/Construction/Teksanlar.webp'
import s from '../Construction/Construction.module.css'
export const Construction = () => {
	return (
		<div className={s.Construction}>
			<div className={s.ConstructionBG}>
				<h3>Construction</h3>
			</div>
			<div className={s.Wrapper}>
				<div className='container'>
					<ul className={s.List}>
						<li className={s.Item}>
							<img src={ArtMetal} alt={'ArtMetal'} />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img src={Atmacan} alt={'Atmacan'} />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img src={Aydogdu} alt={'Aydogdu'} />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img src={MetGun} alt={'MetGun'} />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img src={MdInsaat} alt={'MdInsaat'} />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img src={Fernas} alt='Fernas' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img src={EzeInsaat} alt='EzeInsaat' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img src={goldIskele} alt={'goldIskele'} />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img src={KozaIskele} alt={'KozaIskele'} />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img src={Kirik} alt={'Kirik'} />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img src={Teksanlar} alt={'Teksanlar'} />
							<p className={s.Desc}></p>
						</li>
					</ul>
				</div>
			</div>
		</div>
	)
}
